import React, { ReactNode } from 'react'

export interface RenderIfProps {
  children?: ReactNode
  when?: boolean
}

const RenderIf = ({ children, when }: RenderIfProps) => {
  return <React.Fragment>{when && children}</React.Fragment>
}
export default RenderIf
